//initial redux
import { put, call, takeEvery, fork, all, takeLatest, select } from "redux-saga/effects";
import { delay } from "redux-saga";
import moment from "moment-timezone";
import evidenceservice from "../../../services/evidence";
import pointsservice from "../../../services/points";

const initialState = {
    isBusy: true,
    gatheredData: [],
    description: "",
    bestIndex: -1,
    hasLoadedData: false,

    currentLoadedIEnergyViewId: null,
    currentLoadedDataType: null,
    currentLoadedId: null,

    extendedChartData: [],
};

/////////
//types
export const types = {
    LOAD_DATA: "evidence/report/LOAD_DATA",
    LOAD_STARTED: "evidence/report/LOAD_STARTED",
    ON_LOAD_DATA: "evidence/report/ON_LOAD_DATA",
    ON_LOAD_DATA_FAILED: "evidence/report/ON_LOAD_DATA_FAILED",

    SET_CHARTS: "evidence/report/SET_CHARTS",
    CLEAR_DATA: "evidence/report/CLEAR_DATA",
    SET_EXTENDED_CHART_DATA: "evidence/report/SET_EXTENDED_CHART_DATA",
    SET_SELECTED_TAB: "evidence/report/SET_SELECTED_TAB",
};

///////////
//reducers
export const reducers = {
	reducer(state = initialState, action) {
		switch (action.type) {
            case types.LOAD_STARTED:
                return {...state, isBusy: true, currentLoadedIEnergyViewId: action.payload.iEnergyViewId, currentLoadedDataType: action.payload.dataType, currentLoadedId: action.payload.id }
            case types.ON_LOAD_DATA:
                return { ...state, isBusy: false, hasLoadedData: true, gatheredData: action.payload.gatheredData, bestIndex: action.payload.bestIndex, description: action.payload.description }
            case types.ON_LOAD_DATA_FAILED:
                return { ...state, isBusy: false, hasLoadedData: true }
            case types.SET_CHARTS:
                return { ...state, 
                    chart0: action.payload.c0, 
                    chart1: action.payload.c1, 
                    chart2: action.payload.c2, 
                    chart3: action.payload.c3, 
                    chart4: action.payload.c4, 
                    chart5: action.payload.c5, 
                    chartCombined: action.payload.cc,
                    costChart: action.payload.cost
                }
            case types.CLEAR_DATA:
                return { ...state, 
                    description: "",
                    bestIndex: -1,
                    chart0: undefined, 
                    chart1: undefined, 
                    chart2: undefined, 
                    chart3: undefined, 
                    chart4: undefined, 
                    chart5: undefined, 
                    chartCombined: undefined, 
                    costChart: undefined,
                    currentLoadedDataType: null, 
                    currentLoadedId: null, 
                    currentLoadedIEnergyViewId: null,
                    gatheredData: [],
                    extendedChartData: [],
                }
            case types.SET_EXTENDED_CHART_DATA:
                return { ...state, extendedChartData: action.payload }
            default:
                return state;
		}
	}
};

function* getValues(obj, fromDate, toDate) {
    let data = {};
    data.units = obj.units;
    data.name = obj.name;
    if(obj.units.toLowerCase() === "kwh" || obj.units.toLowerCase() === "count" || obj.units.toLowerCase() === "seats") {
        let values = yield call(pointsservice.TrendableDataGetData, obj.objectID, fromDate, toDate, null, null, null, null, true);
        
        data.value = values.reduce(function(prev, curr){
            return prev + curr.value;
        }, 0);
    } else {
        // need min, average, max, so... 
        let min = yield call(pointsservice.TrendableDataGetData, obj.objectID, fromDate, toDate, null, null, null, null, true, "Minimum");
        let avg = yield call(pointsservice.TrendableDataGetData, obj.objectID, fromDate, toDate, null, null, null, null, true, "Average");
        let max = yield call(pointsservice.TrendableDataGetData, obj.objectID, fromDate, toDate, null, null, null, null, true, "Maximum");

        data.min = min.reduce(function(a, b) {return a.value <= b.value ? a : b}, {value: Number.MAX_VALUE}).value;
        if(data.min === Number.MAX_VALUE) {
            data.min = 0;
        }
        data.avg = avg.reduce(function(a, b) {return {value: a.value + b.value}}, {value: 0} ).value / avg.length;
        data.max = max.reduce(function(a, b) {return a.value > b.value ? a : b}, {value: 0}).value;
    }

    return data;
}

function getView(flattenedSiteTree, rootView, paths){
	let result = null;

	let wkView = rootView;
	if(flattenedSiteTree && rootView && paths && paths.length && flattenedSiteTree.Roots.length){
		for(var ii = 0; ii < paths.length; ii++){
			let wkPath = paths[ii];
         let nextView = null;
         
         const childs = flattenedSiteTree.GetChildrenFor(wkView);

         for (let index = 0; index < childs.length; index++) {
            const childView = childs[index];
            if(childView.name === wkPath){
               nextView = childView;
               break;
            }
         }

			if(!nextView){
				break;
			}else{
				wkView = nextView;
			}
			if(ii === paths.length - 1){
				result = wkView;
			}
		}
	}

	return result;
}

const dateFormat = "YYYY-MM-DD HH:mm:ss";

function sortCosts(hourlyCosts){
	let sorted = [];

	//if nothing then nope
	if(!hourlyCosts){
		return sorted;
	}

	for(var something in hourlyCosts) {
		if(hourlyCosts.hasOwnProperty(something)) {
			hourlyCosts[something].forEach(s => {
				sorted.push({
					timestamp: s.timestamp,
					value: s.value,
					period: something
				});
			})
		}
	}
/*
	//grab the 3 periods
	const offPeak = hourlyCosts["OffPeak"];
	const peak = hourlyCosts["Peak"];
	const shoulder = hourlyCosts["Shoulder"];

	//loop over all periods and add to same array while castign timestamps to moment objects and adding the period as a prop.
	if(offPeak && offPeak.length){
		offPeak.forEach(s => {
			sorted.push({
				timestamp: s.timestamp,
				value: s.value,
				period: "offPeak",
			});
		});
	}

	if(peak && peak.length){
		peak.forEach(s => {
			sorted.push({
				timestamp: s.timestamp,
				value: s.value,
				period: "peak",
			});
		});
	}

	if(shoulder && shoulder.length){
		shoulder.forEach(s => {
			sorted.push({
				timestamp: s.timestamp,
				value: s.value,
				period: "shoulder",
			});
		});
	}
*/
    //now sort the array
	sorted.sort(function(a, b){
        var ad = moment(a.timestamp);
        var bd = moment(b.timestamp);
		if(ad > bd){
			return 1;
		}else if (ad < bd){
			return -1;
		}else{
			return a.value - b.value;
		}
    });

	//finally, for some dumbass reason the api call returns the first hour for every period, even if it's not relevent,
	//i.e if time period requests is form 8am-10am, the peak, off-peak, and shoulder will all have values for 8am even though only 1 period should.
	//so now we need to go through and remove teh shitty entries.
	let removalCount = 0;
	for(var ii = 0; ii < sorted.length; ii++){
		//teh dodgy values should always be at start of array with value of zero.
		//Propblem is 0 is a legit value so cant just remove all 0, need to also check the datetime to make sure it's a dupe
		if(sorted[ii].value === 0
			 && ii < sorted.length - 1
			 && new Date(sorted[ii].timestamp).getTime() === new Date(sorted[ii + 1].timestamp).getTime()){
			removalCount++;
		}else{
			//shitty values are at start so no ned to loop through all valeus once we find a good value
			break;
		}
	}

    sorted.splice(0, removalCount);

	return sorted;
}

//////////
//sagas
export const sagas = {
	*rootSaga() {
		yield all([
            this.onLoadData(),
            this.onSetSelectedTab(),
        ]);
    },
    *onSetSelectedTab() {
        yield takeEvery(types.SET_SELECTED_TAB, function*({payload}) {
            let { index, c0, c1, c2, c3, c4, c5, cc } = payload;

            yield delay(250);

            switch(index) {
                case "combined": if(cc && cc.current && cc.current.chart && cc.current.chart.reflow) { cc.current.chart.reflow(); } break;
                case 0: if(c0 && c0.current && c0.current.chart && c0.current.chart.reflow) { c0.current.chart.reflow(); } break;
                case 1: if(c1 && c1.current && c1.current.chart && c1.current.chart.reflow) { c1.current.chart.reflow(); } break;
                case 2: if(c2 && c2.current && c2.current.chart && c2.current.chart.reflow) { c2.current.chart.reflow(); } break;
                case 3: if(c3 && c3.current && c3.current.chart && c3.current.chart.reflow) { c3.current.chart.reflow(); } break;
                case 4: if(c4 && c4.current && c4.current.chart && c4.current.chart.reflow) { c4.current.chart.reflow(); } break;
                case 5: if(c5 && c5.current && c5.current.chart && c5.current.chart.reflow) { c5.current.chart.reflow(); } break;
                default:
                    break;
            }
        });
    },
    *onLoadData() {
        yield takeEvery(types.LOAD_DATA, function*({payload}) {
            yield delay(1000);
            let { iEnergyViewId, dataType, id, siteName, c0, c1, c2, c3, c4, c5, cc, cost } = payload;
            if(iEnergyViewId === "null") {
                iEnergyViewId = undefined;
            }
            
            const evidenceReport = yield select(x => x.evidenceReport);
			const sitetree = yield select(x => x.sitetree);
            const tariff = yield select(x => x.tariffs);
            
            if(!sitetree || !sitetree.flattenedSiteTree || !tariff || !tariff.currentTariff || !tariff.currentTariff.tariffPK) {
                console.log("Ignoring LOAD_DATA");
                return;
            }

            if(evidenceReport.currentLoadedIEnergyViewId === iEnergyViewId && evidenceReport.currentLoadedDataType === dataType && evidenceReport.currentLoadedId === id) {
                console.log("Already loaded or loading this data");
                return;
            }

            if((dataType !== "PreSetTest" && dataType !== "ImplementedChange") || !id) {
                yield put(actions.onLoadDataFailed("No preSetTestId or implementedChangeId"));
                yield call(payload.navigateFunc, "/Evidence");
            }

            yield put(actions.onLoadStarted(payload));

            let description = "";
            let bestCosts = -1;
            let bestCostsIndex = -1;

            let dataDateRanges = [];

            switch(dataType) {
                case "PreSetTest":
                    {
                        let preSetTest = yield call(evidenceservice.GetPreSetTestById, id);

                        description = preSetTest ? preSetTest.description : "";
                    
                        if(preSetTest && preSetTest.preSetTestItems) {
                            preSetTest.preSetTestItems.forEach((pstItem) => {
                                dataDateRanges.push({description: pstItem.description, fromDate: pstItem.fromDate, toDate: pstItem.toDate})
                            })
                        }

                        break;
                    }
                case "ImplementedChange":
                    {
                        let implementedChange = yield call(evidenceservice.GetImplementedChangeById, id);

                        description = implementedChange ? implementedChange.description : "";

                        if(implementedChange.implementedOn && implementedChange.implementedEnd) {
                            dataDateRanges.push({fromDate: moment(implementedChange.implementedOn), toDate: moment(implementedChange.implementedEnd)});
                        }

                        if(implementedChange.comparePeriodFromDate1) {
                            let fromDate1 = moment(implementedChange.comparePeriodFromDate1);
                            let toDate1 = moment(implementedChange.comparePeriodFromDate1).add(implementedChange.lengthDays, 'days');
                            dataDateRanges.push({description: "Previous Period", fromDate: fromDate1, toDate: toDate1});
                        }

                        if(implementedChange.comparePeriodFromDate2) {
                            let fromDate2 = moment(implementedChange.comparePeriodFromDate2);
                            let toDate2 = moment(implementedChange.comparePeriodFromDate2).add(implementedChange.lengthDays, 'days');
                            dataDateRanges.push({description: "Same time last year", fromDate: fromDate2, toDate: toDate2});
                        }

                        if(implementedChange.comparePeriodFromDate3) {
                            let fromDate3 = moment(implementedChange.comparePeriodFromDate3);
                            let toDate3 = moment(implementedChange.comparePeriodFromDate3).add(implementedChange.lengthDays, 'days');
                            dataDateRanges.push({description: "Similar Period 1", fromDate: fromDate3, toDate: toDate3});
                        }

                        if(implementedChange.comparePeriodFromDate4) {
                            let fromDate4 = moment(implementedChange.comparePeriodFromDate4);
                            let toDate4 = moment(implementedChange.comparePeriodFromDate4).add(implementedChange.lengthDays, 'days');
                            dataDateRanges.push({description: "Similar Period 2", fromDate: fromDate4, toDate: toDate4});
                        }

                        if(implementedChange.comparePeriodFromDate5) {
                            let fromDate5 = moment(implementedChange.comparePeriodFromDate5);
                            let toDate5 = moment(implementedChange.comparePeriodFromDate5).add(implementedChange.lengthDays, 'days');
                            dataDateRanges.push({description: "Similar Period 3", fromDate: fromDate5, toDate: toDate5});
                        }

                        break;
                    }
                default:
                    break;
            }


            let customData = yield all(dataDateRanges.map((dataDateRange, index) => call(getRangeData, sitetree.flattenedSiteTree, siteName, bestCosts, bestCostsIndex, tariff, iEnergyViewId, dataDateRange, index)));

            customData.forEach((data, index) => {
                if((data.costs < bestCosts && moment(new Date()) > moment(data.startDate) && moment(new Date()) > moment(data.endDate)) || bestCosts === -1) {
                    bestCosts = data.costs;
                    bestCostsIndex = index;
                }
            });

            yield put(actions.onLoadData(description, bestCostsIndex, customData));

            yield delay(1000);

            addDataToCharts(customData, c0.current ? c0.current.chart : null, c1.current ? c1.current.chart : null, c2.current ? c2.current.chart : null, c3.current ? c3.current.chart : null, c4.current ? c4.current.chart : null, c5.current ? c5.current.chart : null, cc.current ? cc.current.chart : null, cost.current ? cost.current.chart : null, bestCostsIndex);

            let extendedChartData = yield all(dataDateRanges.map((dataDateRange, index) => call(getChartData, sitetree.flattenedSiteTree, siteName, iEnergyViewId, dataDateRange, index)));
            
            let sortedExtendedChartData = [];
            for(var ii = 0; ii < extendedChartData.length; ii++) {
                let index = 0;
                for(var jj in extendedChartData[ii]) {
                    if(extendedChartData[ii].hasOwnProperty(jj)) {
                        if(!sortedExtendedChartData[index]) {
                            sortedExtendedChartData[index] = [];
                        }
                        sortedExtendedChartData[index].push(extendedChartData[ii][jj]);
                    }
                    index++;
                }
            };
            
            yield put(actions.setExtendedChartData(sortedExtendedChartData));
        });
    },
};

function* getChartData(flattenedSiteTree, siteName, iEnergyViewId, dataDateRange, index) {
    let newChartData = [];
    
    let points = [];
    if(iEnergyViewId) {
        let sets = flattenedSiteTree.First(x => x.objectID === iEnergyViewId);
        if(sets) {
            for(var s in sets._tree.children) { // Evidence/Set/
                if(sets._tree.children.hasOwnProperty(s)) {
                    let views = flattenedSiteTree[sets._tree.children[s]];
                    for(var v in views._tree.children) { // Evidence/Set/View/
                        if(views._tree.children.hasOwnProperty(v)) {
                            let point = flattenedSiteTree[views._tree.children[v]];
                            points.push({description: views.name, child: point});
                        }
                    }
                }
            }
        }
    }

    if(points.length > 0) {
        for(var p in points) {
            if(points.hasOwnProperty(p)) {
                if(!newChartData[points[p].description]) {
                    newChartData[points[p].description] = [];
                }
                let values = yield call(pointsservice.TrendableDataGetData, points[p].child.objectID, dataDateRange.fromDate, dataDateRange.toDate, null, null, null, null, true);

                let data = [];
                values.forEach((v) => {
                    data.push({x: v.timestamp, y: v.value, timestamp: v.timestamp, units: points[p].child.units});
                });

                newChartData[points[p].description].push({description: points[p].description, fromDate: dataDateRange.fromDate, toDate: dataDateRange.toDate, values: data});
            }
        }
    }

    return newChartData;
}

function* getRangeData(flattenedSiteTree, siteName, bestCosts, bestCostsIndex, tariff, iEnergyViewId, dataDateRange, index) {
    let costs = 0;
    let kWh = 0;
    let demandMin = 0;
    let demandMax = 0;
    var chartCosts = [];
    
    var energyCostsKwh = null;
    let currentSite = flattenedSiteTree.First(x => x.name === siteName);

    let values = [];
    let points = [];
    if(iEnergyViewId) {
        let view = flattenedSiteTree.First(x => x.objectID === iEnergyViewId);
        if(view) {
            for(var v in view._tree.children) { // Evidence/Set/Views
                if(points.length > 2) {
                    break;
                }
                if(view._tree.children.hasOwnProperty(v)) {
                    let vpoints = flattenedSiteTree[view._tree.children[v]];

                    if(vpoints.name === "Meters") {
                        energyCostsKwh = vpoints;
                    } else {
                        for(var vp in vpoints._tree.children) { // Evidence/Set/View/Points
                            if(vpoints._tree.children.hasOwnProperty(vp)) {
                                points.push({description: view.name, child: flattenedSiteTree[vpoints._tree.children[vp]]});
                                break;
                            }
                        }
                    }
                }
            }
        }
    }

    if(!energyCostsKwh) {
        energyCostsKwh = getView(flattenedSiteTree, currentSite, ["Meters", "Main"]);
    }

    if(energyCostsKwh) {
        var eck = yield call(pointsservice.TrendableDataGetData, energyCostsKwh.objectID, moment(dataDateRange.fromDate), moment(dataDateRange.toDate), null, null, "Hourly", null, true);
        var ecd = yield call(pointsservice.TrendableDataGetData, energyCostsKwh.objectID, moment(dataDateRange.fromDate), moment(dataDateRange.toDate), tariff.currentTariff.tariffPK, tariff.currentTariffVersion, "Hourly", null, true);

        var sortedEcd = sortCosts(ecd);

        kWh = eck.reduce(function(kWh, obj) {
            return kWh + obj.value;
        }, 0);

        costs = sortedEcd.reduce(function(costs, obj) {
            return costs + obj.value;
        }, 0);

        demandMin = sortedEcd.reduce(function(a, b) {return a.value <= b.value ? a : b}, {value: Number.MAX_VALUE}).value;
        if(demandMin === Number.MAX_VALUE) {
            demandMin = 0;
        }
        demandMax = sortedEcd.reduce(function(a, b) {return a.value >= b.value ? a : b}, {value: 0}).value;

        for(var jj = 0; jj < sortedEcd.length; jj++) {
            chartCosts.push({x: jj, y: sortedEcd[jj].value, timestamp: sortedEcd[jj].timestamp});
        }
    }

    if(points.length > 0) {
        for(var p in points) {
            if(points.hasOwnProperty(p)) {
                let value = yield call(getValues, points[p].child, dataDateRange.fromDate, dataDateRange.toDate);
                value.description = points[p].description;
                values.push(value);
            }
        }
    }

    // sort the values
    values = values.sort(sortDegC);
    if(values.length === 1 && values[0].units === "degC") {
        values = [{}, {}, values[0]];
    } else if(values.length === 2 && values[1].units === "degC") {
        values = [values[0], {}, values[1]];
    }

    return {description: dataDateRange.description, costs, kWh, demandMin, demandMax, values, startDate: dataDateRange.fromDate, endDate: dataDateRange.toDate, chartCosts};
}

function sortDegC(a, b) {
    if(a.units === "degC") {
        return 1;
    }
    if(a.units !== "degC") {
        return -1;
    }
    return 0;
}

function addDataToCharts(gatheredData, c0, c1, c2, c3, c4, c5, cc, cost, bestCostsIndex) {
    if(!c0 || !c1 || !c2 || !c3 || !c4 || !c5 || !cc || !cost) {
        return;
    }

    if(cc.series.length) {
        cc.series[0].update({data: [], name: " ", label: " "}, false);
        cc.series[1].update({data: [], name: " ", label: " "}, false);
        cc.series[2].update({data: [], name: " ", label: " "}, false);
        cc.series[3].update({data: [], name: " ", label: " "}, false);
        cc.series[4].update({data: [], name: " ", label: " "}, false);
        cc.series[5].update({data: [], name: " ", label: " "}, false);

        let ii = 6;
        gatheredData.forEach((gd, index) => {
            cc.series[index].update({
                name: moment(gd.startDate).format("DD MMM") + " - " + moment(gd.endDate).format("DD MMM") + " (" + moment(gd.startDate).format("YYYY") + ")",
                pointPadding: 0,
                groupPadding: 0,
                label: moment(gd.fromDastartDatete).format("DD MMM") + " - " + moment(gd.endDate).format("DD MMM") + " (" + moment(gd.startDate).format("YYYY") + ")",
                borderWidth: 0,
                turboThreshold: 0,
                data: [],
            }, false);
            ii++;
        });

        while(ii < 6) {
            cc.addSeries({data: [], name: " ", label: " "});
            ii++;
        }
    } else {
        let jj = 0;
        gatheredData.forEach(gd => {
            cc.addSeries({
                name: moment(gd.startDate).format("DD MMM") + " - " + moment(gd.endDate).format("DD MMM") + " (" + moment(gd.startDate).format("YYYY") + ")",
                pointPadding: 0,
                groupPadding: 0,
                label: moment(gd.startDate).format("DD MMM") + " - " + moment(gd.endDate).format("DD MMM") + " (" + moment(gd.startDate).format("YYYY") + ")",
                borderWidth: 0,
                turboThreshold: 0,
                data: [],
            });
            jj++;
        });

        while(jj < 6) {
            cc.addSeries({data: [], name: " ", label: " "});
            jj++;
        }
    }

    let maxNumOfPoints = 0;

    while(cost.series.length > 0) {
        cost.series[0].remove(true);
    }

    for(var ii = 0; ii < gatheredData.length; ii++) {
        let chart = null;
        let numOfPoints = 0;
        switch(ii) {
            case 0: chart = c0; break;
            case 1: chart = c1; break;
            case 2: chart = c2; break;
            case 3: chart = c3; break;
            case 4: chart = c4; break;
            case 5: chart = c5; break;
            default: break;
        }

        if(chart.series) {
            chart.series[0].update({data: [], name: " ", label: " "});
        } else {
            chart.addSeries({data: [], name: " ", label: " "});
        }

        for(var jj = 0; jj < gatheredData[ii].chartCosts.length; jj++) {
			if(gatheredData[ii].chartCosts[jj] && gatheredData[ii].chartCosts[jj].x && gatheredData[ii].chartCosts[jj].y) {
                chart.series[0].addPoint({x: gatheredData[ii].chartCosts[jj].x, y: gatheredData[ii].chartCosts[jj].y, timestamp: gatheredData[ii].chartCosts[jj].timestamp}, false);
                cc.series[ii].addPoint({x: gatheredData[ii].chartCosts[jj].x, y: gatheredData[ii].chartCosts[jj].y, timestamp: gatheredData[ii].chartCosts[jj].timestamp}, false);
                numOfPoints++;
            }
        }

        if(numOfPoints > maxNumOfPoints) {
            maxNumOfPoints = numOfPoints;
        }

        var dateName = moment(gatheredData[ii].startDate).format("DD MMM YYYY") + " - " + moment(gatheredData[ii].endDate).format("DD MMM YYYY");
        cost.addSeries({data: [gatheredData[ii].costs], name: dateName, label: dateName, color: ii === bestCostsIndex ? "#009EC0" : "#556cab"});
    }


    
	c0.xAxis[0].setExtremes(0, maxNumOfPoints);
	c1.xAxis[0].setExtremes(0, maxNumOfPoints);
	c2.xAxis[0].setExtremes(0, maxNumOfPoints);
	c3.xAxis[0].setExtremes(0, maxNumOfPoints);
	c4.xAxis[0].setExtremes(0, maxNumOfPoints);
	c5.xAxis[0].setExtremes(0, maxNumOfPoints);
	cc.xAxis[0].setExtremes(0, maxNumOfPoints);

    c0.redraw();
    c1.redraw();
    c2.redraw();
    c3.redraw();
    c4.redraw();
    c5.redraw();
    cc.redraw();
    cost.redraw();

    c0.reflow();
    c1.reflow();
    c2.reflow();
    c3.reflow();
    c4.reflow();
    c5.reflow();
    cc.reflow();
    cost.reflow();
}

////////
//actions
export const actions = {
    loadData(iEnergyViewId, dataType, id, siteName, navigateFunc, c0, c1, c2, c3, c4, c5, cc, cost) {
        return {
            type: types.LOAD_DATA,
            payload: {iEnergyViewId, dataType, id, siteName, navigateFunc, c0, c1, c2, c3, c4, c5, cc, cost}
        }
    },
    onLoadStarted(payload) {
        return {
            type: types.LOAD_STARTED,
            payload
        }
    },
    onLoadData(description, bestIndex, gatheredData) {
        return {
            type: types.ON_LOAD_DATA,
            payload: {description, bestIndex, gatheredData}
        }
    },
    onLoadDataFailed(payload) {
        return {
            type: types.ON_LOAD_DATA_FAILED,
            payload
        }
    },
    setCharts(c0, c1, c2, c3, c4, c5, cc) {
        return {
            type: types.SET_CHARTS,
            payload: {c0, c1, c2, c3, c4, c5, cc}
        }
    },
    clearData() {
        return {
            type: types.CLEAR_DATA,
        }
    },
    setExtendedChartData(payload) {
        return {
            type: types.SET_EXTENDED_CHART_DATA,
            payload
        }
    },
    setSelectedTab(index, c0, c1, c2, c3, c4, c5, cc) {
        return {
            type: types.SET_SELECTED_TAB,
            payload: { index, c0, c1, c2, c3, c4, c5, cc }
        }
    },

	genericAction(type, data) {
		return {
			type,
			payload: data
		};
	}
};



// WEBPACK FOOTER //
// ./src/ui/Evidence/Report/redux.js